import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appAutofocusDirective]'
})
export class AutofocusDirectiveDirective implements OnInit {
  constructor(private elementRef: ElementRef) { };

  ngOnInit(): void {
    this.elementRef.nativeElement.focus();
  }


}
